import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface IOptions {
  data?: object;
  activeData?: object;
  changeSelection?: any
}

@Component
export default class Options extends tsx.Component<IOptions> {
  
  @Prop() public data?: object;
  @Prop() public activeData?: object;
  @Prop() public changeSelection?: any
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {title,subtitle,officialPrice,price,subscriptName,id} = this.$props.data;
    console.log(subscriptName);
    return (
      <div onClick={() => this.$props.changeSelection(this.$props.data)} class={`options-container ${this.$props.activeData.id === id ? 'recommended-color' : 'default-color'}`}>
        
        {subscriptName === '1' ? <div class='subscript'>
          <img src={require('@/assets/svg/subscript.svg')} alt=""/>
          <span class='text'>推荐</span>
        </div> : null}
          
          <div>
            <div class='title'>{title}</div>
            <div class='content-container'>
              <div class='subtitle'>
                {subtitle ? <img src={require('@/assets/svg/fire.svg')} alt=""/> : null}
                {subtitle}
                </div>
              <div class='content-right'>
                {officialPrice? <div class='price'>{officialPrice}</div> : null}
                <div class='actual-price'>{price / 100}</div>
                <div class='unit'>元</div>
              </div>
            </div>
          </div>
      </div>
    )
  }
  
}